import {
  messageId,
  PropertyMeta,
  ValueObjectMetaString,
} from "@pscsrvlab/psc-react-components";
import { z } from "zod";
const minimalSchema = z.string().max(10000);
const savedMinimalSchema = z.string().max(10000);
const schema = z.string().min(1).max(10000);
const savedSchema = z.string().min(1).max(10000);
const jsonSchema = z.string();
/**
 * 分化細胞提供理由(値オブジェクト)のメタデータ。
 *
 *  */
export const differentiatedCellProvisionReasonMeta = new ValueObjectMetaString(
  "DifferentiatedCellProvisionReason",
  "\u5206\u5316\u7D30\u80DE\u63D0\u4F9B\u7406\u7531",
  messageId("lbl.\u5206\u5316\u7D30\u80DE\u63D0\u4F9B\u7406\u7531"),
  minimalSchema,
  schema,
  jsonSchema,
  undefined,
  undefined
);
